<!-- begin breadcrumb -->
<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item active">Administración</li>
</ol>
<!-- end breadcrumb -->
<!-- begin page-header -->
<h1 class="page-header"><i class="fas fa-wrench"></i> Nóminas<small> </small></h1>
<!-- end page-header -->

<div class="row gx-4">
    <div class="card border-0 mb-4">
        <app-search-payroll></app-search-payroll>
    </div>
</div>